// Vue
import { mountApp, setupSentry } from "@/main.js";
import store from '@/pages/homepage/store.js';
import HomePage from '@/pages/homepage/HomePage.vue';
import 'vite/modulepreload-polyfill';

const homepage = mountApp(HomePage, {store: store});
const sentry = setupSentry(homepage);
homepage.config.globalProperties.$sentry = sentry;
homepage.mount('#homepage');
